import type { SetsKey } from './keys';

export const nl: Partial<Record<SetsKey, string>> = {
  'app.title': 'Verzamelingen',
  'app.eyebrow': 'Wiskunde · Verzamelingen',
  'app.tagline': 'Interactieve verzamelingenleer-experimenten',
  'app.panel.heading': 'Parameters',
  'btn.advanced': 'Geavanceerd',
  'btn.reset': 'Herstel',
  'btn.randomise': 'Willekeurig',
};
